import { useForm } from "react-hook-form";
import { Input } from "../ui/input";
import { AddTags, IAppResponse } from "@/controllers/appController";
import { forwardRef, useContext } from "react";
import { Button } from "../ui/button";
import { AppContext } from "../Context/AppContext";
import { toast } from "sonner";

interface FormValues {
    key: string;
    value: string;
};

interface AddTagsFormProps {
    appName: string
    setIsOpen: (arg: boolean) => void;
}

export const AddTagsForm = forwardRef<HTMLButtonElement, AddTagsFormProps>(({ appName, setIsOpen }, ref) => {
    const { register, handleSubmit, reset } = useForm<FormValues>();
    const { token } = useContext(AppContext)

    async function onSubmit(data: FormValues) {
        setIsOpen(false)
        reset();
        const response: IAppResponse = await AddTags(appName, data.key, data.value, token);
        if (response.result) {
            toast.success("Tag adicionada ao arquivo web.config")
            return
        }
        toast.error(response.error)
    }

    return (
        <form className="space-y-8 w-full" onSubmit={handleSubmit(onSubmit)}>
            <div className="flex w-full h-full items-center space-x-2">
                <Input
                    id="key"
                    placeholder="Chave"
                    required
                    {...register("key")}
                />
                <Input
                    id="value"
                    placeholder="Valor"
                    required
                    {...register("value")}
                />
                <Button type="submit" ref={ref}>Adicionar</Button>
            </div>
        </form>
    );
});

